import React, { useState, useEffect } from "react";
import { Modal, Col } from "react-bootstrap";
import CalenderIcon from "../../../../assets/images/calendar-icon.svg";
import { KeyboardDatePicker } from "@material-ui/pickers";
import FormInput from "../../../../Utility/FormInput";
import { formatDate } from "../../../../Utility";
import moment from "moment";
import toast from "react-hot-toast";

const AutomaticPaymentScheduleModal = ({
  title,
  amount,
  nextDueDate,
  show,
  updateModalShow,
  automaticPayment,
  resetValues,
  isMember,
}) => {
  const [inputAmount, setInputAmount] = useState();
  const [selectedDate, setSelectedDate] = useState(
    nextDueDate ? moment(formatDate(nextDueDate))?.format("YYYY-MM-DD") : moment().add(1, "day").format("YYYY-MM-DD")
  );
  const isValid = () => {
    if (Number(inputAmount) > 10000) {
      toast.error(
        "This transaction was not processed as the account is not permitted to transfer funds greater than $10,000."
      );
      return false;
    }
    return true;
  };
  useEffect(() => {
    setInputAmount(amount);
  }, [amount]);
  const resetValuesAndClose = () => {
    setInputAmount(amount);
    const selectedD = nextDueDate
      ? moment(formatDate(nextDueDate))?.format("YYYY-MM-DD")
      : moment().format("YYYY-MM-DD");
    setSelectedDate(selectedD);
    updateModalShow(false);
  };
  return (
    <Modal
      show={show}
      onHide={() => {
        resetValues();
        updateModalShow(false);
      }}
      className="modal-style-1 w-100"
      size="md"
    >
      <Modal.Header>
        <Modal.Title as="h3" className="w-100 text-center">
          {isMember ? "Choose First Payment Date" : "Choose Payment Amount & Date"}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {!isMember && (
          <Col xl={6}>
            <FormInput
              placeholder="$"
              prefix="$"
              type="maskInput"
              label="Your Rent Amount"
              name="payment_amount"
              value={inputAmount}
              setValue={setInputAmount}
              guide={false}
              thousandsSeparator
              className="w-100"
            />
          </Col>
        )}
        <p className="mt-4 card-title">
          The date you choose here will be the date your account will be debited each month.
        </p>
        <div className="mt-4">
          <label className="mb-2">When should this payment be made?</label>
          <KeyboardDatePicker
            value={selectedDate}
            className="form-control"
            format="MM/DD/YYYY"
            onChange={(date) => setSelectedDate(date)}
            variant="inline" //static
            disableToolbar
            autoOk
            InputAdornmentProps={{ position: "end" }}
            keyboardIcon={<img src={CalenderIcon} />}
            disablePast
            //min date is tomorrow
            minDate={moment().add(1, "day").format("YYYY-MM-DD")}
          />
        </div>
        <p className="mt-4 card-title">
          You may cancel this payment at any time. Any payments scheduled after your move out date will automatically be
          canceled.{" "}
        </p>
      </Modal.Body>
      <div className="row modal-btns mt-4">
        <div className="col-6">
          <button type="button" className="btn btn-warning w-100" onClick={() => updateModalShow(false)}>
            Cancel
          </button>
        </div>
        <div className="col-6">
          <button
            onClick={() => {
              const formattedDate = moment(selectedDate).format("YYYY-MM-DD");
              if (isValid()) {
                automaticPayment(formattedDate, inputAmount);
                resetValuesAndClose();
              }
            }}
            type="button"
            className="btn btn-primary w-100"
            data-cy="continue"
          >
            Continue
          </button>
        </div>
      </div>
    </Modal>
  );
};
export default AutomaticPaymentScheduleModal;
